import { useMemo } from 'react';

import { window } from '../../globals';
import type { DeploymentFeature } from '../../../shared/deploymentFeatures';

/**
 * Whether a deployment-wide feature is enabled. Deployment features are switched on by the deployment's
 * config (chart values), not per organization; for per-organization flags use `isFeatureEnabled`.
 *
 * Reads `window.deploymentFeatures`, which the HTML shell hydrates from the backend config. Pages
 * rendered without the session middleware (the fatal error page and the public attribution page) see
 * every feature as off.
 */
export const isDeploymentFeatureEnabled = (feature: DeploymentFeature): boolean =>
  window.deploymentFeatures?.[feature] ?? false;

/**
 * Hook form of `isDeploymentFeatureEnabled`. The hydrated set never changes for the life of the page,
 * so the result only depends on the feature name.
 */
export const useIsDeploymentFeatureEnabled = (feature: DeploymentFeature): boolean =>
  useMemo(() => isDeploymentFeatureEnabled(feature), [feature]);
